/**
 * Matches DropdownTermDate filtering so madang labels align with the selected term list.
 * If a school has 3+ terms in the filtered set, index >= 1 uses second-semester-style labels (3·4마당).
 */
export function filterTermPeriodRows(
  termPeriodData,
  schoolYearId,
  hierarchyOneId = "",
  hierarchyTwoId = "",
) {
  let filteredData = (termPeriodData || []).slice().sort((a, b) =>
    String(a.start_date).localeCompare(String(b.start_date)),
  );

  filteredData = filteredData.filter(
    (data) =>
      data.school_year_id.toString() === String(schoolYearId || ""),
  );

  const hierarchyOneFiltered = filteredData.filter((data) => {
    const dataValue = data.applied_hierarchy_one?.toString();
    const filterValue = hierarchyOneId?.toString();
    return dataValue === filterValue;
  });

  if (hierarchyOneFiltered.length > 0) {
    const hierarchyTwoFiltered = hierarchyOneFiltered.filter((data) => {
      const dataValue = data.applied_hierarchy_two?.toString();
      const filterValue = hierarchyTwoId?.toString();
      return dataValue === filterValue;
    });

    if (hierarchyTwoFiltered.length > 0) {
      filteredData = hierarchyTwoFiltered;
    } else {
      filteredData = hierarchyOneFiltered.filter(
        (data) =>
          data.applied_hierarchy_two === null ||
          data.applied_hierarchy_two === "",
      );
    }
  } else {
    filteredData = filteredData.filter(
      (data) =>
        data.applied_hierarchy_one === null ||
        data.applied_hierarchy_one === "",
    );
  }

  return filteredData;
}

/** @returns { [string, string] } display names for intel blocks "1" and "2" */
export function getMadangPairLabels(termPeriodData, filters) {
  const { schoolYearId, hierarchyOneId, hierarchyTwoId, termId } = filters;
  const rows = filterTermPeriodRows(
    termPeriodData,
    schoolYearId,
    hierarchyOneId,
    hierarchyTwoId,
  );
  if (!termId || rows.length === 0) {
    return ["1마당", "2마당"];
  }
  const idx = rows.findIndex(
    (r) => String(r.id) === String(termId),
  );
  const isSecondSemester = idx >= 1;
  return isSecondSemester ? ["3마당", "4마당"] : ["1마당", "2마당"];
}
